import React, { useState, useEffect, useRef } from 'react'
import { styled } from "@mui/material/styles";
import { makeStyles, Button, Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";

import { getRelationship } from '../../actions/subscribe'
import {message} from 'antd'
import G6 from '@antv/g6';

import closeSvg from '../../assets/svg/delete.svg'
import flowSvg from '../../assets/images/icon-flow.svg'

const useStyles = makeStyles({
  box: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '960px',
    maxWidth: '80vw',
    background: '#fff',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.2)',
    borderRadius: '20px'
  },
  title: {
    width: '100%',
    height: '50px',
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e9e9e9',
    fontSize: '18px !important',
    color: '#333',
    boxSizing: 'border-box',
    fontWeight: 'bold !important',
    '& img': {
      cursor: 'pointer',
      marginRight: '7px',
      marginTop: '-2px'
    }
  },
  infoBox: {
    width: '100%',
    minHeight: '770px',
    boxSizing: 'border-box',
  },
 
});
export default function FlowModal(props) {
  const { fileId } = props
  const classes = useStyles();


  

  useEffect(() => {
    init()
  }, [fileId])

  const fittingString = (str, maxWidth, fontSize) => {
    let currentWidth = 0;
    let result = ''
    let subLen = 0
    const pattern = new RegExp('[\u4E00-\u9FA5]+'); // distinguish the Chinese charactors and letters
    str.split('').forEach((letter, i) => {
      if (currentWidth > maxWidth) return;
      if (pattern.test(letter)) {
        currentWidth += fontSize;
      } else {
        currentWidth += G6.Util.getLetterWidth(letter, fontSize);
      }
      if (currentWidth > maxWidth) {
        currentWidth = 0
        result += str.substring(subLen, i) + '\n'
        subLen = i
      } 
    });
    if (result) {
      return result + str.substring(subLen)
    } else {
      return str
    }
  };

  const init = () => {
    let form = new FormData()
    form.append('base_file_id', fileId)
    getRelationship(form).then(res => {
      let list = res.results
      let nodes = []
      let edges = []
      list.forEach((v, i) => {
        //节点
        nodes.push({
          id: v.origin_base_file.file_id + '',
          fullName: v.origin_base_file.file_name,
          label: v.origin_base_file.file_name.length > 38 ? (v.origin_base_file.file_name.substring(0, 35) + '...'): v.origin_base_file.file_name,
          url: v.origin_base_file.dfs_url,
          isLong: v.origin_base_file.file_name.length > 38
        })
        nodes.push({
          id: v.referenced_base_file_id.file_id + '',
          fullName: v.referenced_base_file_id.file_name,
          label: v.referenced_base_file_id.file_name.length > 38 ? (v.referenced_base_file_id.file_name.substring(0, 35) + '...' ): v.referenced_base_file_id.file_name,
          url: v.referenced_base_file_id.dfs_url,
          isLong: v.referenced_base_file_id.file_name.length > 38
        })
        
        //关系
        edges.push({
          source: v.origin_base_file.file_id + '',
          target: v.referenced_base_file_id.file_id + '',
          label: v.relationship
        })
      })
      
      const newNodes = [...new Map(nodes.map(item => [item.id, item])).values()];
      let data = {
        nodes: newNodes,
        edges
      }
      console.log(111, data)
      // return
      initDiagram(data, fileId)
    })
  }

  const initDiagram = (data, id) => {

    //箭头属性
    data.edges.forEach((edge) => {
      edge.style = {
        endArrow: true,
        stroke: '#39C07A',
        lineWidth: 3,
      }
      edge.labelCfg = {
        autoRotate: true,
        refY: 8,
        style: {
          fill: '#000',
          fontSize: 12,
          fontWeight: 600
        }
      }
    });

    let index = data.nodes.findIndex(v => {
      return v.id == id
    })
    console.log(222, id, index)

    //节点属性
    data.nodes.forEach((node, i) => {
      node.labelCfg = {
        style: {
          fill: '#fff',
          textAlign: 'center',
          cursor: 'pointer',
          fontWeight: 500
        }
      }
      if (i === index) {
        node.label = fittingString(node.label, 130, 19)
        node.style = {
          fill: '#1890FF',
          stroke: '#1890FF',
        }
        node.size = 180
        node.labelCfg.style.fontSize = 19
        node.labelCfg.style.fontWeight = 600
      } else {
        let size = node.isLong ? 150 : 120
        let textSize = size == 120 ? 95 : 110
        let fontSize = size == 120 ? 14 : 16
        node.labelCfg.style.fontSize = fontSize
        node.label = fittingString(node.label, textSize, fontSize)
        node.size = size
        node.style = {
          fill: '#39C07A',
          stroke: '#39C07A'
        }
      }
    })

    const tooltip = new G6.Tooltip({
      offsetX: 10,
      offsetY: 20,
      getContent(e) {
        const outDiv = document.createElement('div');
        outDiv.style.width = '200px';
        outDiv.innerHTML = `
          <div style="work-break: break-all;">${e.item.getModel().fullName}</div>
        `
        return outDiv
      },
      itemTypes: ['node']
    });

    const graph = new G6.Graph({
      container: 'mountNode', 
      width: 960, 
      height: 760,
      fitView: false,
      layout: {
        type: 'force',
        preventOverlap: true,
        nodeSpacing: 30
      },
      plugins: [tooltip],
      modes: {
        default: ['zoom-canvas', 'drag-canvas', 'drag-node'],
      },
    });


    graph.on('node:click', evt => {
      jumpLink(evt)
    })


    graph.data(data); //
    graph.render(); 
  }

  const jumpLink = (e) => {
    if (e.item._cfg && e.item._cfg.model && e.item._cfg.model.url) {
      let url = e.item._cfg.model.url
      let a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }

  return (
    <Grid className={classes.box}>
      {/* <Typography className={classes.title}>
        <Typography variant="span">
          参考件
        </Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg}/>
        </Typography>

      </Typography> */}
      
      <Grid className={classes.modalBody}>
        <Grid className={classes.infoBox} id="mountNode">
          
        </Grid>
      </Grid>
      
      
     
    </Grid>
  )
}
